module.exports = window.CocosPlan;